import { useUnit } from 'effector-react';
import { musicMaster } from 'shared/lib';
import MusicOffIcon from 'shared/ui/assets/icons/music-off-icon.svg?react';
import MusicOnIcon from 'shared/ui/assets/icons/music-on-icon.svg?react';
import { SidebarSlider } from '../sidebar-slider';

export const SidebarMusicSlider = () => {
	const [volume, setVolume] = useUnit([musicMaster.$volume, musicMaster.setVolume]);

	return (
		<SidebarSlider
			iconOn={<MusicOnIcon />}
			iconOff={<MusicOffIcon />}
			value={volume}
			onChange={setVolume}
		/>
	);
};
